
var Modal = require('app/ui/Modal');

class Waiting extends Modal {

	defaultOptions(){
		var self = this;
		var options = {
			//modal options
			'modalClass': 'waiting-modal',
			'verticalCentered': true,
			'modalSize': 'medium',
			'showFooter': false,
			'showHeader': false,
			'staticModal': true,

			//confirmModal options
			'messageClass': 'waiting-modal-message',
			'messageContent': window.translate('processing'),
			'showLoader': true
		};
		return Object.assign(super.defaultOptions(),options);
	}

	initialize(){
		super.initialize();

		this.setBodyContent(this.buildContent());
	}

	buildContent(){
		var self = this;

		var $content = $('<div/>')
		.addClass('text-center');

		this.$message = $('<div/>')
		.addClass(this.settings.messageClass)
		.append(this.settings.messageContent);

		$content
		.append(this.$message);


		if(this.settings.showLoader){
			this.$message
			.append(window.App.generateLoader());
		}
		
		return $content;
	}

}

module.exports = Waiting;